// components/IsAppReady.js
import Button from "antd/es/button";
import notification from "antd/es/notification";
import {getTokenKey} from 'helpers/localStorage'
import get from 'lodash/get'
import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import useNetwork from "react-use/lib/useNetwork";
import {updateApp} from 'redux/actions'
import {LoginContext} from './LoginContext'
import {IS_CORDOVA} from "../envs/_current/config";
import SocketProvider from "modules/socket/SocketProvider";
import {isDevelop} from "../envs/ForDevelop";

// ─── Selector ─────────────────────────────────────────────────────────────────
const selectLogin = (state) => {
    const id = get(state, 'auth.user.username')
    return get(state, 'entities.users.' + id, get(state, 'auth.user'))
}
const selectAuthSuccess = (state) => state.auth?.success

// ─── NetworkTracking (không thay đổi) ────────────────────────────────────────
const NetworkTracking = () => {
    const dispatch = useDispatch()
    const netWorkState = useNetwork()
    useEffect(() => {
        let timeout
        if (!netWorkState.online && !navigator.onLine) {
            timeout = setTimeout(() => {
                notification.error({
                    key: 'netWorkOffline',
                    message: 'netWork',
                    description: 'offline',
                    btn: (
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => window.location.reload()}>
                            reconnect
                        </Button>
                    ),
                })
                dispatch(updateApp({online: netWorkState.online}))
            }, 1000)
        } else {
            notification.destroy('netWorkOffline')
            dispatch(updateApp({online: netWorkState.online}))
        }
        return () => {
            if (timeout) clearTimeout(timeout)
        }
    }, [dispatch, netWorkState.online])
    return null
}

// ─── IsAppReady ───────────────────────────────────────────────────────────────
export const IsAppReady = ({children}) => {
    const login = useSelector(selectLogin)
    const authSuccess = useSelector(selectAuthSuccess)
    const token = getTokenKey()

    // ready = true khi:
    // 1. Không có token (guest)
    // 2. auth.success = true (API /me đã trả về)
    // 3. auth đã có dữ liệu persist từ localStorage (success đọc từ INITIAL_STATE)
    //    → trường hợp này authSuccess = true ngay từ đầu mà không cần đợi API
    const ready = !token || !!authSuccess

    // Key chỉ đổi khi token thay đổi (login/logout)
    // Không đổi theo ready → tránh remount toàn bộ cây con
    const contextKey = token || 'anonymous';

    if (isDevelop()) {
        return (
            <>
                <LoginContext.Provider key={contextKey} value={login}>
                    {ready ? children : null}
                </LoginContext.Provider>
            </>
        )
    }

    return (
        <>
            {!IS_CORDOVA && <NetworkTracking/>}
            <LoginContext.Provider key={contextKey} value={login}>
                <SocketProvider>
                    {ready ? children : null}
                </SocketProvider>
            </LoginContext.Provider>
        </>
    )
}